
<div class=" o-modal--medium" id="termsEmployee"  style="width: 100%;">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" (click)="Close()"  matDialogClose></a>
          <label class="o-title o-title--white o-title--medium"> {{'ModalExceptionConfirmPortal.title' | translate}}</label> 
    </div>
    <mat-dialog-content style="width:95%; margin: 10px;">
            <div class="o-modal__text">
                <span  style="white-space: pre-line;"  >{{'ModalExceptionConfirmPortal.termsDescription' | translate}}</span>
            </div>
    </mat-dialog-content>
    <div class="o-modal__footer">
         <div>
             <button mat-button mat-dialog-close (click)="Close()" class="btn btn--default " style="color:black" ><u> {{'ModalExceptionConfirmPortal.btnCancel' | translate}}</u></button>
            <button mat-button (click)="Accept()" class="btn btn--primary" > {{'ModalExceptionConfirmPortal.btnAccept' | translate}} </button>
        </div> 
    </div>
</div>
